module.exports = __webpack_public_path__ + "resources/img/main02_gov.6a3294fd763637c4e4491e4a8cfd3180.jpg";